export default "__VITE_ASSET__DRZJiOkT__"